import React, { useState, Fragment, useEffect } from "react";
import { Collapse, Modal } from "@material-ui/core";
import { Link } from "react-router-dom";
import serviceProvider from "../../services/axios";
import Plyr from "plyr-react";
import "plyr-react/dist/plyr.css";
import "./maturity-dashboard-admin-page.scss";
import {
  MaturityPlantSetupPopup,
  MaturitySubmitDataPopup,
  AssignSectionPopup,
  MaturityAddUserPopup,
} from "./maturity-admin-popup";

export const SidebarView = (props) => {
  const curl = window.location.pathname.split("/");
  const firstSeg = curl[1];
  const inHomeArr = ["educate-prepare-home", "home-tour"];
  const homeClass = inHomeArr.indexOf(firstSeg) != -1 ? "active" : "";
  const f1Class = firstSeg == "framework" ? "active" : "";
  const f2Class = firstSeg == "industry-40-dimensions" ? "active" : "";
  const f3Class = firstSeg == "digital-plant" ? "active" : "";
  const f4Class = firstSeg == "cpgstudy" ? "active" : "";
  const inCourseArr = [
    "training-courses",
    "course_overview",
    "course_details",
    "course_quiz",
  ];
  const courseClass = inCourseArr.indexOf(firstSeg) != -1 ? "active" : "";
  const inLearnArr = ["learning-center"];
	const LearningClass = inLearnArr.indexOf(firstSeg) != -1 ? "active" : "";
  const [isUpgradePopup, setIsUpgradePopup] = useState(false);
  const [isLnrCollapse, setIsLnrCollapse] = useState(true);
  const [groupid, setGroupId] = useState("");
  const [isvideoPopup, setIsvideoPopup] = useState(false);
  const [isAddUserPopup, setIsAddUserPopup] = useState(false);
  const [isAddPlantPopup, setIsAddPlantPopup] = useState(false);
  const [isSubmitDataPopup, setIsSubmitDataPopup] = useState(false);
  const [isAssignSectionPopup, setIsAssignSectionPopup] = useState(false);
  const [isPlantClicked, setIsPlantClicked] = useState(false);
  const [asspopup, setAssPopup] = useState([]);
  const HandleUpdgradePopup = () => {
    setIsUpgradePopup(!isUpgradePopup);
  };
  const user = JSON.parse(localStorage.getItem("userData"));
  const usid = user ? user.uid : 0;
  const login = localStorage.getItem("isLoggedIn");
  const openAssPopup = (e) => {
    //const getVal = $(e.target).attr("data-id");
    //setAssPopup(getVal);
    //setIsAssignSectionPopup(true);
  };
  useEffect(() => {
    serviceProvider
      .post("/plants?type=usergroupid", JSON.stringify({ uid: usid }), true)
      .then((response) => {
        const data = response.data;
        setGroupId(data);
        if (login) {
          localStorage.setItem("group_id", data);
        }
      });
  }, []);

  useEffect(() => {
    const { showSidebarPopUp, isQuizPage, history } = props;
    if (isPlantClicked && showSidebarPopUp && isQuizPage) {
      history.push("/");
    }
  }, [props.showSidebarPopUp]);

  const handlePlantClick = () => {
    if (props.isQuizPage) {
      setIsPlantClicked(true);
    } else {
      setIsAddUserPopup(true);
    }
  };

  const handleOtherClicks = () => {
    setIsPlantClicked(false);
  };
  const HandleVideoPopup = () => {
    setIsvideoPopup(!isvideoPopup);
  };
  return (
    <Fragment>
      <aside
        className={
          props.expanded
            ? props.isSidebar
              ? "ng-sidebar active"
              : "ng-sidebar"
            : "ng-sidebar"
        }
      >
        <div className="ng-sidebar-wrapper">
          <div className="ng-sidebar-header">
            <Link to="/" onClick={handleOtherClicks}>
              <img
                src={
                  require("../../assets/img/sidebar-img/team-header-logo.svg")
                    .default
                }
                className="logo-expend"
                alt="true"
              />
              <img
                src={
                  require("../../assets/img/sidebar-img/team-header-logo-min.svg")
                    .default
                }
                className="logo-collapse"
                alt="true"
              />
            </Link>
          </div>
          <nav className={props.isSidebar ? "" : "ng-hide-pay"}>
            <ul className="ng-level1-nav-list-wrapper">
              <li className="ng-level1-li">
                <Link
                  to={
                    groupid == 14
                      ? "/educate-prepare-home"
                      : groupid == 11
                      ? "/educate-prepare-home"
                      : "/"
                  }
                  className={`ng-level1-a ${homeClass}`}
                  onClick={handleOtherClicks}
                >
                  <span className="ng-nav-img">
                    <img
                      src={
                        require(`../../assets/img/sidebar-img/home-inactive.svg`)
                          .default
                      }
                      className="in-active"
                      alt="true"
                    />
                    <img
                      src={
                        require(`../../assets/img/sidebar-img/home-active.svg`)
                          .default
                      }
                      className="active"
                      alt="true"
                    />
                  </span>
                  <div className="ng-nav-txt side-collapse">
                    {/*<span>My Actions</span>*/}
                    <span>Home</span>
                  </div>
                </Link>
                {groupid != 14 ? (
                  <Link
                    to="#"
                    className="ng-level1-a cursor-pointer"
                    onClick={handlePlantClick}
                  >
                    <span className="ng-nav-img">
                      <img
                        src={
                          require(`../../assets/img/sidebar-img/exclude.svg`)
                            .default
                        }
                        className="in-active"
                        alt="true"
                      />
                      <img
                        src={
                          require(`../../assets/img/sidebar-img/exclude-active.svg`)
                            .default
                        }
                        className="active"
                        alt="true"
                      />
                    </span>

                    <div className="ng-nav-txt plant-add-svg side-collapse">
                      <span>My Plants</span>

                      <img
                        src={
                          require("../../assets/img/sidebar-img/plant-add.svg")
                            .default
                        }
                        alt="Add"
                        className="ed_addpl_btn"
                      />
                    </div>
                  </Link>
                ) : (
                  ""
                )}
                <Link
                  to="/training-courses"
                  className={`ng-level1-a ${courseClass}`}
                  onClick={handleOtherClicks}
                >
                  <span className="ng-nav-img">
                    <img
                      src={
                        require(`../../assets/img/sidebar-img/training.svg`)
                          .default
                      }
                      className="in-active"
                      alt="true"
                    />
                    <img
                      src={
                        require(`../../assets/img/sidebar-img/training-active.svg`)
                          .default
                      }
                      className="active"
                      alt="true"
                    />
                  </span>
                  <div className="ng-nav-txt side-collapse">
                    <span>My Trainings</span>
                  </div>
                </Link>
                {/* Learning center start */}
								<Link to="/learning-center" className={`ng-level1-a ${LearningClass}`} onClick={handleOtherClicks}  >
								
                <span className="ng-nav-img">
                  <img src={require(`../../assets/img/sidebar-img/learning.svg`).default} className="in-active" alt="true" />
                  <img
                    src={require(`../../assets/img/sidebar-img/learning-active.svg`).default}
                    className="active"
                    alt="true"
                  />
                </span>		
              <div className="ng-nav-txt side-collapse">
                  <span className="" >
                  Resource Center
                  </span>
                </div>
              </Link>
              {/* Learning center end */} 
              {/* <span className="ng-level1-a cursor-pointer">
                  <span
                    className="ng-nav-img lnr-img"
                    onClick={() => {
                      props.handleExpand();
                    }}
                  >
                    <img
                      src={
                        require(`../../assets/img/sidebar-img/learning.svg`)
                          .default
                      }
                      className="in-active"
                      alt="true"
                    />
                    <img
                      src={
                        require(`../../assets/img/sidebar-img/learning-active.svg`)
                          .default
                      }
                      className="active"
                      alt="true"
                    />
                  </span>
                  <div className="ng-nav-txt side-collapse">
                    <span
                      className="ed_lrn_rsc"
                      onClick={() => setIsLnrCollapse(!isLnrCollapse)}
                    >
                      Learning and Resources
                    </span>
                    <img
                      src={
                        require("../../assets/img/sidebar-img/nav-ddl-arrow.svg")
                          .default
                      }
                      alt="true"
                      onClick={() => setIsLnrCollapse(!isLnrCollapse)}
                      style={{
                        trnsition: ".25s",
                        transform: `rotate(${
                          isLnrCollapse ? "0deg" : "-90deg"
                        })`,
                      }}
                    />
                  </div>
                </span>
                <div className="lar-ddl-wrapper">
                  <Collapse in={isLnrCollapse}>
                    <ul className="ng-level2-nav-list-wrapper slidedown">
                      <li className="ng-level2-li">
                        <Link
                          to="/framework"
                          onClick={handleOtherClicks}
                          className={`ng-level2-a ${f1Class}`}
                        >
                          <span>Framework</span>
                        </Link>
                      </li>
                      <li className="ng-level2-li">
                        <a
                          href="https://apishowcasen.smarterchains.com/vendor"
                          onClick={handleOtherClicks}
                          className={`ng-level2-a ${f2Class}`}
                        >
                          <span>Vendor discovery</span>
                        </a>
                      </li>
                      <li className="ng-level2-li">
                        <Link
                          to="/industry-40-dimensions"
                          onClick={handleOtherClicks}
                          className={`ng-level2-a ${f2Class}`}
                        >
                          <span>Industry 4.0 Dimensions</span>
                        </Link>
                      </li>
                      <li className="ng-level2-li">
                        <Link
                          to="/digital-plant"
                          onClick={handleOtherClicks}
                          className={`ng-level2-a ${f3Class}`}
                        >
                          <span>Digital Plant Archetypes</span>
                        </Link>
                      </li>
                      <li className="ng-level2-li">
                        <Link
                          to="/cpgstudy"
                          onClick={handleOtherClicks}
                          className={`ng-level2-a ${f4Class}`}
                        >
                          <span>CPG Industry Study</span>
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </div> */}
              </li>
            </ul>
            <div className="ng_card" style={{display:'none'}}>
              <div className="ng_card_head">
                <span className="ed_webcst-ttl">webcast</span>
              </div>
              <button className="lai40-btn" onClick={HandleVideoPopup}>
                <img
                  src={
                    require("../../assets/img/home-index/quikstart-2.svg")
                      .default
                  }
                  alt="true"
                  style={{ maxWidth: "100%" }}
                />
              </button>
              <div className="text-wrap">
                <h2 className="ng_card_heading">
                  Start your Industry 4.0 Journey
                </h2>
                <p className="ng_card_text">
                  Learn more about one of the world’s top Frameworks for
                  Industry 4.0 Transformation
                </p>
              </div>
            </div>
          </nav>
        </div>
        <div className="ng-toggle-icon">
          <span className="ng-toggle-wrap">
            <span
              className={
                props.expanded
                  ? "ng-slide-img maximize ng-side-hide"
                  : "ng-slide-img maximize"
              }
              onClick={() => {
                props.handleChange();
              }}
            >
              <img
                src={
                  require(`../../assets/img/sidebar-img/maximize.svg`).default
                }
                alt="true"
              />
              <img
                src={
                  require(`../../assets/img/sidebar-img/maximize-hover.svg`)
                    .default
                }
                className={
                  props.expanded
                    ? "ng-slide-img maximize-hover"
                    : "ng-slide-img maximize-hover"
                }
                onClick={() => {
                  props.handleChange();
                }}
                alt="true"
              />
            </span>

            <span
              className={
                props.expanded
                  ? "ng-slide-img minimize"
                  : "ng-slide-img minimize ng-side-hide"
              }
              onClick={() => {
                props.handleChange();
              }}
            >
              <img
                src={
                  require(`../../assets/img/sidebar-img/minimize.svg`).default
                }
                alt="true"
              />
              <img
                src={
                  require(`../../assets/img/sidebar-img/minimize-hover.svg`)
                    .default
                }
                className={
                  props.expanded
                    ? "ng-slide-img minimize-hover"
                    : "ng-slide-img minimize-hover"
                }
                onClick={() => {
                  props.handleChange();
                }}
                alt="true"
              />
            </span>
          </span>
        </div>
      </aside>
      <MaturityPlantSetupPopup
        open={isAddPlantPopup}
        setOpen={setIsAddPlantPopup}
        {...props}
      />
      <MaturitySubmitDataPopup
        open={isSubmitDataPopup}
        setOpen={setIsSubmitDataPopup}
        {...props}
      />
      <AssignSectionPopup
        open={isAssignSectionPopup}
        setOpen={setIsAssignSectionPopup}
        assessmentPopup={asspopup}
        {...props}
      />
      <MaturityAddUserPopup
        open={isAddUserPopup}
        setOpen={setIsAddUserPopup}
        setAddPlantPopup={setIsAddPlantPopup}
        {...props}
      />
      <Modal
        open={isUpgradePopup}
        // onClose={HandleUpdgradePopup}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className="home-index-upgrade-popup"
      >
        <div className="upgrade-popup-content">
          <button className="close-btn" onClick={HandleUpdgradePopup}>
            <img
              src={
                require("../../assets/img/common-img/close-icon-blue.svg")
                  .default
              }
              alt="close"
            />
          </button>
          <div className="upgrd-popup-img">
            <img
              src={
                require("../../assets/img/home-index/digital-maturity.gif")
                  .default
              }
              alt="digital_maturity"
            />
          </div>
          <div className="upgrd-popup-body">
            <h2 className="h1">
              Buy full Digital Maturity Assessment to Unlock Plants
            </h2>
            <p>
              Upgrade to the plan that best matches your profile and start the
              Assessment as early as today.
            </p>
            <Link
              to="/plans"
              className="btn-upgrade-now"
              onClick={HandleUpdgradePopup}
            >
              Upgrade Now{" "}
            </Link>
          </div>
        </div>
      </Modal>

      {/*home index main-course-page end*/}
      <Modal
        open={isvideoPopup}
        onClose={HandleVideoPopup}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className="quick-start-vid-popup"
      >
        <div className="vid__wrapper custom_vid__wrapper">
          <Plyr
            source={{
              type: "video",
              sources: [
                {
                  src: "https://apishowcasen.smarterchains.com/assets/videos/intro.mp4",
                  type: "video/mp4",
                },
              ],
            }}
            options={{
              controlshidden: true,
            }}
          />
        </div>
      </Modal>
      {/*quick-start-vid-popup end*/}
    </Fragment>
  );
};
